export default "__VITE_ASSET__Bma_vpcC__"